import { useState, useEffect } from "react";

import React from "react";
import { Button, Card } from "react-bootstrap";
import BannersTable from "./OrdersTable";
import OrdersModal from "./OrdersModal";

import Loader from "../../components/Loader";
import { getHostName } from "../../helpers/utils";
import API from "../../api/api";
import { useAuth } from "../../context/AuthContext";

const Orders = () => {
  const hostname = getHostName();

  const [dataList, setDataList] = useState([]);

  const [loader, setLoader] = React.useState(false);

  const [payload, setPayload] = React.useState({});

  const {user} = useAuth();

  //  modal
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getDataList();
  }, []);

  const getDataList = () => {
    API.get(`${hostname}/api/checkout/orders`)
      .then((res) => {
        console.log(res.data);
        setDataList(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const createEntry = () => {
    let obj = {};
    obj.loadType = "Upload Banner";

    setPayload({ ...obj });
    handleShow();
  };

  const viewEntry = (obj = {}) => {
    obj.loadType = "View Order";
    console.log(obj);

    setPayload({ ...obj });
    handleShow();
  };

  const updateEntry = (obj) => {
    obj.loadType = "Update Banner";

    setPayload({ ...obj });
    handleShow();
  };

  const deleteEntry = (obj) => {
    obj.loadType = "Delete Banner";

    setPayload({ ...obj });
    handleShow();
  };

  if (loader) {
    return <Loader />;
  } else {
    return (
      <div>
        <Card>
          <Card.Body className="overflow-hidden" style={{ minHeight: "90vh" }}>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
              className="mb-3"
            >
              <h4>Orders</h4>
            </div>

            <br />
            <BannersTable
              list={dataList}
              viewEntry={viewEntry}
              updateEntry={updateEntry}
              deleteEntry={deleteEntry}
            />
            <br />

            <OrdersModal
              show={show}
              handleClose={handleClose}
              payload={payload}
              setPayload={setPayload}
              getAllData={getDataList}
              hostname={hostname}
              user={user}
            />
          </Card.Body>
        </Card>
      </div>
    );
  }
};

export default Orders;
